/* eslint-disable import/no-anonymous-default-export */
export default {
  GENERATE_OTP: () => "/customer/auth/generateMobileOtp",
  LOGIN_WITH_OTP: () => "/customer/auth/loginWithMobileOtp",
  UPDATE_PROFILE: () => "/customer/auth/updateProfile",
  GET_PROFILE: () => "/customer/myProfile",
};
